import * as React from 'react'
import styled from 'styled-components'

import {
  media,
  Col,
  MeetupIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MediumIcon,
  Row,
} from 'cc-ui-components'

const Wrapper = styled.div`
  width: 100%;
  max-width: 908px;
`

const Content = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  ${media.sm`
    flex-wrap: wrap;
  `};
  a {
    display: flex;
    justify-content: center;
    flex-basis: 33%;
    margin-top: 3em;
  }
  svg {
    object-fit: contain;
    width: 37px;
    height: 35px;
    &#linked-in {
      width: 34px;
      height: 30px;
      path {
        fill: #007ebb;
      }
    }
  }
`

const IconsSection: React.SFC<{}> = () => {
  return (
    <Wrapper>
      <Row>
        <Col sm={12.3} md={12.3} lg={10.3} center>
          <Content>
            <a href="https://www.facebook.com/codecontrol.io/" target="_blank">
              <FacebookIcon />
            </a>
            <a href="https://twitter.com/CodeControl_" target="_blank">
              <TwitterIcon />
            </a>
            <a
              href="https://www.meetup.com/Future-of-Work-Berlin/"
              target="_blank"
            >
              <MeetupIcon />
            </a>
            <a
              href="https://www.linkedin.com/company/codecontrol/"
              target="_blank"
            >
              <LinkedinIcon />
            </a>
            <a href="https://medium.com/future-of-work" target="_blank">
              <MediumIcon />
            </a>
            <a href="https://www.instagram.com/codecontrol.io/" target="_blank">
              <InstagramIcon />
            </a>
          </Content>
        </Col>
      </Row>
    </Wrapper>
  )
}

export default IconsSection
